import clientConfig from "../../client-config";

// EU + EEA + UK + CA country codes, requiring active consent before any tracking.
// The entire US (including California) is treated as non-restricted.
const GDPR_COUNTRIES = new Set([
  "AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GR", "HR",
  "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI",
  "SK", "GB", "NO", "IS", "LI", "CH", "CA"
]);

// Returns a Promise<boolean> — true if visitor is in a GDPR/privacy-regulated region.
// Priority: ?geo= URL param → sessionStorage cache → IPinfo Lite API fetch.
// Uses a free IPinfo Lite token (unlimited, country-level data only).
// Fails open: if lookup fails, unknown location defaults to tracking.
export async function detectGdprRegion() {
  if (typeof window === "undefined") return true;

  // Override: ?geo=eu → GDPR, ?geo=<anything else> → not GDPR
  const geoParam = new URLSearchParams(window.location.search).get("geo");
  if (geoParam !== null) return geoParam === "eu";

  // Session cache — avoid re-fetching on every page navigation
  const cached = sessionStorage.getItem("geo-region");
  if (cached !== null) return cached === "gdpr";

  try {
    const res = await fetch(
      `https://api.ipinfo.io/lite/me?token=${clientConfig.ipinfo.token}`,
      // Site sets a global `Referrer-Policy: no-referrer` header (netlify.toml), so
      // override it just for this request — IPinfo's domain allowlist needs the
      // origin to identify the caller. "origin" sends only scheme+host, no path/query.
      { referrerPolicy: "origin" }
    );
    const { country_code: countryCode } = await res.json();
    const isGdpr = GDPR_COUNTRIES.has(countryCode);
    sessionStorage.setItem("geo-region", isGdpr ? "gdpr" : "world");
    return isGdpr;
  } catch {
    return false;
  }
}
